<template>
    <div class="progress" :class="size">
        <div class="progress-bar"
             :class="`bg-${style} ${ intermediate ? 'progress-bar-striped progress-bar-animated' : ''}`"
             role="progressbar"
             :style="`width: ${progress}%`"
             :aria-valuenow="value"
             :aria-valuemin="min"
             :aria-valuemax="max"></div>
    </div>
</template>

<script>
export default {
    name: "ProgressBar",

    props: {
        min:            {type: Number,  default: 0},
        max:            {type: Number,  default: 100},
        value:          {type: Number,  default: 0},
        intermediate:   {type: Boolean, default: false},
        style:          {type: String,  default: 'primary'},
        size:           {type: String,  default: 'md'},
    },

    computed: {

        total(){
            return this.max - this.min;
        },

        progress(){
            return Math.ceil(this.total / 100 * (this.value - this.min) * 10) / 10;
        }
    }

}
</script>

<style lang="scss" scoped>
.progress{

    &.xl{
        height: 2rem;
    }

    &.lg{
        height: 1.5rem;
    }

    &.sm{
        height: 0.5rem;
    }

    &.xs{
        height: 0.3rem;
    }

}
</style>
